import PageForm from '../form'

const AboutUs = () => <PageForm title="About Us" Key="about-us" />

export default AboutUs
